module.exports = __webpack_public_path__ + "img/examples-en-4.d89ee60a.jpg";